import React, { useMemo } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import { companiesData } from "AllDummyData/DummyData";


const StatsCard = () => {

    const stats = useMemo(() => {
        const total = companiesData.length;
        const active = companiesData.filter(c => c.status === "Active").length;
        const pending = companiesData.filter(c => c.status === "Pending").length;
        const inactive = companiesData.filter(c => c.status === "Inactive").length;

        return [
            { title: "Total Companies", value: total, icon: "🏢", color: "#06aed4", bgColor: "#f0faff" },
            { title: "Active Companies", value: active, icon: "📋", color: "#27ae60", bgColor: "#f0fff4" },
            { title: "Pending Approval", value: pending, icon: "⏳", color: "#ef1e1e", bgColor: "#fff1f2" },
            { title: "Inactive Accounts", value: inactive, icon: "🚫", color: "#7539ff", bgColor: "#f0eef6" },
        ];
    }, [companiesData]);

    return (
        <Row className="g-4 mb-4"> {/* Added g-4 for consistent gaps */}
            {stats.map((stat, index) => (
                <Col key={index} xl="3" md="6">
                    <Card className="shadow-sm border-0 h-100" style={{ borderRadius: "12px" }}>
                        <CardBody className="d-flex align-items-center p-3">
                            <div className="d-flex align-items-center justify-content-center me-3"
                                style={{
                                    minWidth: "48px",
                                    height: "48px",
                                    backgroundColor: stat.bgColor,
                                    borderRadius: "10px",
                                    fontSize: "22px",
                                    color: stat.color
                                }}>
                                {stat.icon}
                            </div>
                            <div>
                                <p className="text-muted mb-0 fs-6 fw-medium small">{stat.title}</p>
                                <h4 className="fw-bold mb-0">{stat.value}</h4>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            ))}
        </Row>
    )
};

export default StatsCard;